import React from "react";
import FooterContent from "./component/FooterContent";
export function Footer(props) {
  if (props.env === "staging") {
    return (
      <div
        className="bg-[#200f6f]
        bg-footer-image
        bg-top
        flex
        justify-center
        pt-[1rem]
        pb-[12.8rem]
        md:pt-[9rem]
        md:pb-[16.5rem]
        1400px:pt-[10rem]
        1400px:pb-[11rem]
        1400px:bg-footer-image-desktop
        1400px:bg-cover"
      >
        <FooterContent />
      </div>
    );
  } else if (props.env === "prod") {
    return (
      <div
      className="bg-[#200f6f]
      bg-footer-image
      bg-top
      flex
      justify-center
      pt-[1rem]
      pb-[12.8rem]
      md:pt-[9rem]
      md:pb-[16.5rem]
      1400px:pt-[10rem]
      1400px:pb-[11rem]
      1400px:bg-footer-image-desktop
      1400px:bg-cover"
      >
        <FooterContent />
      </div>
    );
  }
}
